export const getters = {
  listPopularSurveys: state => {
    return state.surveys;
  }
};
